import { getRecordType } from '@xbcb/core';
import { getRecordPath } from 'libs/getRecordPath';

/**
 * Generates a hyperlink URL for a work order
 * @param workOrderId - The work order ID
 * @return Promise that resolves to full hyperlink URL to the work order, or empty string if invalid
 */

export const getWorkOrderHyperlink = async (
  workOrderId: string,
): Promise<string> => {
  if (!workOrderId || typeof workOrderId !== 'string') {
    return '';
  }

  const recordType = getRecordType(workOrderId);
  if (!recordType) {
    return '';
  }

  const path = getRecordPath({ recordType, id: workOrderId });
  return `${window.location.origin}${path}`;
};
